<div class="container-fluid p-0">
  <div class="row no-gutters">
    <div class="col-lg-2">
      <app-navbar></app-navbar>
    </div>
    <div class="col-lg-10 contenido">
      <div class="d-flex align-items-center justify-content-between">
        <h4 class="mb-0">Variaciones (V2)</h4>
        <span *ngIf="loading" class="badge badge-info">Cargando...</span>
      </div>
      <hr />

      <div class="card mb-3">
        <div class="card-body">
          <h6 class="card-title">Agregar variacion base</h6>
          <div class="form-row align-items-end">
            <div class="col-md-3">
              <div class="d-flex justify-content-between">
                <label class="font-weight-bold">Tipo</label>
                <button type="button" class="btn btn-secondary btn-sm" (click)="abrirAgregarTipo(tipoVariacionModal, 'nuevo')">Agregar</button>
              </div>
              <select class="form-control" [(ngModel)]="formVariacion.tipo">
                <option value="" disabled>Selecciona tipo</option>
                <option *ngFor="let tipo of getTiposVariacion()" [value]="tipo">{{ tipo }}</option>
              </select>
            </div>
            <div class="col-md-4">
              <label class="font-weight-bold">Nombre</label>
              <input class="form-control" [(ngModel)]="formVariacion.nombre" placeholder="Ej. Principal, Secundaria, Extra" />
            </div>
            <div class="col-md-2">
              <label class="font-weight-bold">Activo</label>
              <select class="form-control" [(ngModel)]="formVariacion.activo">
                <option [value]="1">Si</option>
                <option [value]="0">No</option>
              </select>
            </div>
            <div class="col-md-3 mt-3 mt-md-0">
              <button class="btn btn-success btn-block" (click)="agregarVariacion()">Guardar</button>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-body">
          <div class="d-flex align-items-center justify-content-between flex-wrap">
            <h6 class="card-title mb-0">Catalogo de variaciones</h6>
            <div class="filters-row">
              <input class="form-control" [(ngModel)]="filtro" placeholder="Buscar variacion" />
              <select class="form-control" [(ngModel)]="filtroTipo">
                <option value="">Todos los tipos</option>
                <option *ngFor="let tipo of getTiposVariacion()" [value]="tipo">{{ tipo }}</option>
              </select>
              <select class="form-control" [(ngModel)]="filtroActivo">
                <option value="">Todas</option>
                <option value="1">Activas</option>
                <option value="0">Inactivas</option>
              </select>
              <button class="btn form-control btn-success" (click)="this.getVariaciones();">
                Buscar
              </button>
              
            </div>
          </div>

          <div class="table-responsive mt-3">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>Id</th>                  
                  <th>Nombre variación</th>
                  <th>Tipo variación</th>
                  <th>Activo</th>
                  <th class="text-right">Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let variacion of variacionesFiltradas">
                  <td>{{ variacion.id }}</td>                  
                  <td>{{ variacion.nombre }}</td>
                  <td>{{ getVariacionTipo(variacion) || '-' }}</td>
                  <td>
                    <span class="badge" [ngClass]="variacion.activo === 0 ? 'badge-secondary' : 'badge-success'">
                      {{ variacion.activo === 0 ? 'No' : 'Si' }}
                    </span>
                  </td>
                  <td class="text-right actions-cell">
                    <button class="btn btn-sm btn-outline-secondary" (click)="configurarVariacion(configuracionesModal, variacion)">Configuraciones (Fotos)</button>
                    <button class="btn btn-sm btn-outline-primary" (click)="seleccionarVariacion(editVariacionModal, variacion)">Editar</button>
                    <button class="btn btn-sm btn-outline-warning" (click)="toggleVariacion(variacion)">
                      {{ variacion.activo === 0 ? 'Activar' : 'Desactivar' }}
                    </button>
                    <button class="btn btn-sm btn-outline-danger" (click)="eliminarVariacion(variacion.id)">Eliminar</button>
                  </td>
                </tr>
                <!-- <tr *ngIf="!variacionesFiltradas.length">
                  <td colspan="5" class="text-center text-muted">Sin variaciones v2.</td>
                </tr> -->
              </tbody>
            </table>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #editVariacionModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="modal-editar-variacion">Editar variacion</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-group">
      <div class="d-flex justify-content-between">
        <label class="font-weight-bold">Tipo</label>
        <button type="button" class="btn btn-secondary btn-sm" (click)="abrirAgregarTipo(tipoVariacionModal, 'editar')">Agregar</button>
      </div>
      <select class="form-control" [(ngModel)]="formVariacionEdit.tipo">
        <option value="" disabled>Selecciona tipo</option>
        <option *ngFor="let tipo of getTiposVariacion(formVariacionEdit.tipo)" [value]="tipo">{{ tipo }}</option>
      </select>
    </div>
    <div class="form-group">
      <label class="font-weight-bold">Nombre</label>
      <input class="form-control" [(ngModel)]="formVariacionEdit.nombre" />
    </div>
    <div class="form-group">
      <label class="font-weight-bold">Activo</label>
      <select class="form-control" [(ngModel)]="formVariacionEdit.activo">
        <option [value]="1">Si</option>
        <option [value]="0">No</option>
      </select>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancelar</button>
    <button type="button" class="btn btn-primary" (click)="actualizarVariacion()">Guardar cambios</button>
  </div>
</ng-template>

<ng-template #tipoVariacionModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="modal-agregar-tipo-variacion">Agregar tipo</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-group">
      <label class="font-weight-bold">Nombre</label>
      <input class="form-control" [(ngModel)]="tipoForm.nombre" placeholder="Ej. Marco, Moldura, Color" />
    </div>
    <div class="form-group">
      <label class="font-weight-bold">Descripcion</label>
      <textarea class="form-control" rows="3" [(ngModel)]="tipoForm.descripcion" placeholder="Detalle interno opcional"></textarea>
    </div>
    <div class="form-group">
      <label class="font-weight-bold">Activo</label>
      <select class="form-control" [(ngModel)]="tipoForm.activo">
        <option [value]="1">Si</option>
        <option [value]="0">No</option>
      </select>
    </div>

    <hr />

    <div class="d-flex align-items-center justify-content-between flex-wrap">
      <h6 class="mb-0">Tipos registrados</h6>
      <input class="form-control tipo-search" [(ngModel)]="filtroTipoCatalogo" placeholder="Buscar tipo" />
    </div>

    <div class="tipo-list mt-3">
      <div class="tipo-row" *ngFor="let tipo of tiposProductoCatalogoFiltrados">
        <div>
          <strong>{{ tipo.nombre }}</strong>
          <small *ngIf="tipo.descripcion">{{ tipo.descripcion }}</small>
          <span class="badge" [ngClass]="tipo.activo === 0 ? 'badge-secondary' : 'badge-success'">
            {{ tipo.activo === 0 ? 'Inactivo' : 'Activo' }}
          </span>
        </div>
        <button type="button" class="btn btn-sm btn-outline-danger" (click)="eliminarTipoProducto(tipo)">Eliminar</button>
      </div>
      <div class="text-muted py-2" *ngIf="!tiposProductoCatalogoFiltrados.length">Sin tipos registrados.</div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancelar</button>
    <button type="button" class="btn btn-primary" (click)="agregarTipoVariacion()">Guardar tipo</button>
  </div>
</ng-template>

<ng-template #configuracionesModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="modal-configuraciones">Items de "{{ getVariacionLabel(variacionConfigurando) }}"</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="d-flex align-items-center justify-content-between flex-wrap">
      <h6 class="mb-0">Configuraciones</h6>
      <input class="form-control config-search" [(ngModel)]="filtroConfig" placeholder="Buscar item" />
    </div>

    <div class="form-row align-items-end mt-3">
      <div class="col-md-3">
        <label class="font-weight-bold">Nombre del item</label>
        <input class="form-control" [(ngModel)]="configForm.configuracion" placeholder="Ej. Moldura de madera" />
      </div>
      <div class="col-md-3">
        <label class="font-weight-bold">Descripcion</label>
        <input class="form-control" [(ngModel)]="configForm.descripcion" placeholder="Ej. Acabado natural, veta visible" />
      </div>
      <div class="col-md-2">
        <label class="font-weight-bold">Imagen</label>
        <input type="file" class="form-control-file" (change)="onConfigFileChange($event)" />
      </div>
      <div class="col-md-1">
        <label class="font-weight-bold">Activo</label>
        <select class="form-control" [(ngModel)]="configForm.activo">
          <option [value]="1">Si</option>
          <option [value]="0">No</option>
        </select>
      </div>
      <div class="col-md-3 mt-3 mt-md-0">
        <button class="btn btn-success btn-block" (click)="agregarConfiguracion()">Agregar</button>
      </div>
    </div>

    <div class="table-responsive mt-3">
      <table class="table table-striped">
        <thead>
          <tr>
            <th>Id</th>
            <th>Item</th>
            <th>Descripcion</th>
            <th>Imagen</th>
            <th>Fotos</th>
            <th>Activo</th>
            <th class="text-right">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let config of configuracionesFiltradas">
            <td>{{ config.id }}</td>
            <td>{{ config.configuracion }}</td>
            <td>{{ config.descripcion || '-' }}</td>
            <td>
              <img *ngIf="config.imagen" [src]="buildImagePath(config.imagen)" alt="img config" class="thumb">
              <span *ngIf="!config.imagen">-</span>
            </td>
            <td>{{ config.imagenes?.length || 0 }}</td>
            <td>{{ config.activo === 0 ? 'No' : 'Si' }}</td>
            <td class="text-right actions-cell">
              <button class="btn btn-sm btn-outline-secondary" (click)="abrirFotosConfiguracion(fotosConfiguracionModal, config)">Fotos</button>
              <button class="btn btn-sm btn-outline-primary" (click)="seleccionarConfiguracion(editConfiguracionModal, config)">Editar</button>
              <button class="btn btn-sm btn-outline-warning" (click)="toggleConfiguracion(config)">
                {{ config.activo === 0 ? 'Activar' : 'Desactivar' }}
              </button>
              <button class="btn btn-sm btn-outline-danger" (click)="eliminarConfiguracion(config.id)">Eliminar</button>
            </td>
          </tr>
          <tr *ngIf="!configuracionesFiltradas.length">
            <td colspan="7" class="text-center text-muted">Sin items.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cerrar</button>
  </div>
</ng-template>

<ng-template #editConfiguracionModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="modal-editar-configuracion">Editar item</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-group">
      <label class="font-weight-bold">Nombre del item</label>
      <input class="form-control" [(ngModel)]="configEditForm.configuracion" />
    </div>
    <div class="form-group">
      <label class="font-weight-bold">Descripcion</label>
      <input class="form-control" [(ngModel)]="configEditForm.descripcion" />
    </div>
    <div class="form-group">
      <label class="font-weight-bold">Activo</label>
      <select class="form-control" [(ngModel)]="configEditForm.activo">
        <option [value]="1">Si</option>
        <option [value]="0">No</option>
      </select>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancelar</button>
    <button type="button" class="btn btn-primary" (click)="actualizarConfiguracion()">Guardar</button>
  </div>
</ng-template>

<ng-template #fotosConfiguracionModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="modal-fotos-configuracion">Fotos de {{ configuracionFotosTarget?.configuracion }}</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-row align-items-end">
      <div class="col-md-4">
        <label class="font-weight-bold">Titulo comun</label>
        <input class="form-control" [(ngModel)]="configuracionImagenForm.titulo" placeholder="Frente, detalle, textura" />
      </div>
      <div class="col-md-2">
        <label class="font-weight-bold">Orden inicial</label>
        <input class="form-control" type="number" [(ngModel)]="configuracionImagenForm.orden" />
      </div>
      <div class="col-md-2">
        <label class="font-weight-bold">Activo</label>
        <select class="form-control" [(ngModel)]="configuracionImagenForm.activo">
          <option [value]="1">Si</option>
          <option [value]="0">No</option>
        </select>
      </div>
      <div class="col-md-4">
        <label class="font-weight-bold">Imagenes</label>
        <input type="file" class="form-control-file" multiple (change)="onConfigImagenesChange($event)" />
      </div>
      <div class="col-md-3 mt-3">
        <button class="btn btn-success btn-block" (click)="agregarFotosConfiguracion()">Agregar fotos</button>
      </div>
      <div class="col-md-9 mt-3 text-muted">
        {{ configuracionImagenFiles.length || 0 }} archivo(s) seleccionados
        <span *ngIf="loadingConfigImagenes"> - Cargando...</span>
      </div>
    </div>

    <div class="gallery-grid mt-4">
      <div class="gallery-item" *ngFor="let imagen of configuracionImagenes">
        <img [src]="buildImagePath(imagen.imagen)" alt="foto configuracion">
        <div>
          <strong>{{ imagen.titulo || 'Sin titulo' }}</strong>
          <small>Orden {{ imagen.orden || 0 }}</small>
          <span class="badge" [ngClass]="imagen.activo === 0 ? 'badge-secondary' : 'badge-success'">
            {{ imagen.activo === 0 ? 'Inactiva' : 'Activa' }}
          </span>
        </div>
        <div class="d-flex justify-content-between mt-2">
          <button class="btn btn-sm btn-outline-warning" (click)="toggleFotoConfiguracion(imagen)">
            {{ imagen.activo === 0 ? 'Activar' : 'Desactivar' }}
          </button>
          <button class="btn btn-sm btn-outline-danger" (click)="eliminarFotoConfiguracion(imagen)">Eliminar</button>
        </div>
      </div>
      <p *ngIf="!configuracionImagenes.length" class="text-muted">Sin fotos adicionales.</p>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cerrar</button>
  </div>
</ng-template>
